import api from '~/api'

const state = {
  version: null,
}

const getters = {}

const mutations = {
  SET_VERSION(state, newVer) {
    state.version = newVer
  },
}

const actions = {
  async getVersion({ commit }, { productId, versionId }) {
    const response = await api.get(
      `/products/${productId}/versions/${versionId}`
    )
    const [error, result] = response

    if (!error) {
      commit('SET_VERSION', result)
    }

    return response
  },

  createVersion(store, { productId, form }) {
    return api.post(`/products/${productId}/versions/`, form)
  },

  async updateVersion({ commit }, { productId, versionId, form }) {
    const response = await api.put(
      `/products/${productId}/versions/${versionId}`,
      form
    )
    const [error, result] = response

    if (!error) {
      commit('SET_VERSION', result)
    }

    return response
  },

  async deleteVersion(ctx, { productId, versionId }) {
    const response = await api.delete(
      `/products/${productId}/versions/${versionId}`)

    return response
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
